import React, { useState } from 'react';
import { checkStorageConnection, testStorageUpload, testCORS } from '../../utils/storageUtils';

const StorageTest = () => {
  const [testResults, setTestResults] = useState(null);
  const [isTesting, setIsTesting] = useState(false);

  const runStorageTests = async () => {
    setIsTesting(true);
    setTestResults(null);
    
    console.log('🚀 Starting Firebase Storage tests...');
    
    const results = {
      cors: false,
      connection: false,
      upload: false,
      errors: []
    };

    try {
      // ทดสอบ CORS ก่อน
      console.log('🌐 Testing CORS...');
      results.cors = await testCORS();
      
      if (results.cors) {
        console.log('✅ CORS test passed');
        
        // ทดสอบการเชื่อมต่อ
        console.log('📡 Testing connection...');
        results.connection = await checkStorageConnection();
        
        if (results.connection) {
          console.log('✅ Connection test passed');
          
          // ทดสอบการอัพโหลด
          console.log('📤 Testing upload...');
          results.upload = await testStorageUpload();
          
          if (results.upload) {
            console.log('✅ Upload test passed');
          } else {
            console.log('❌ Upload test failed');
            results.errors.push('Upload test failed');
          }
        } else {
          console.log('❌ Connection test failed');
          results.errors.push('Connection test failed');
        }
      } else {
        console.log('❌ CORS test failed');
        results.errors.push('CORS test failed - check Firebase Storage configuration');
      }
      
    } catch (error) {
      console.error('❌ Test suite failed:', error);
      results.errors.push(`Test suite error: ${error.message}`);
    }
    
    setTestResults(results);
    setIsTesting(false);
    
    // แสดงผลลัพธ์
    if (results.cors && results.connection && results.upload) {
      alert('✅ ทดสอบ Firebase Storage สำเร็จ! ระบบพร้อมใช้งาน');
    } else {
      alert(`❌ ทดสอบ Firebase Storage ล้มเหลว\n\nErrors:\n${results.errors.join('\n')}`);
    }
  };

  return (
    <div className="p-6 bg-white rounded-lg shadow-md">
      <h2 className="text-xl font-semibold mb-4">🧪 ทดสอบ Firebase Storage</h2>
      
      <div className="space-y-4">
        <p className="text-gray-600">
          คลิกปุ่มด้านล่างเพื่อทดสอบการเชื่อมต่อ Firebase Storage และการอัพโหลดไฟล์
        </p>
        
        <button
          onClick={runStorageTests}
          disabled={isTesting}
          className={`px-6 py-3 rounded-lg font-medium transition ${
            isTesting
              ? 'bg-gray-400 text-white cursor-not-allowed'
              : 'bg-blue-500 text-white hover:bg-blue-600'
          }`}
        >
          {isTesting ? 'กำลังทดสอบ...' : 'เริ่มทดสอบ Firebase Storage'}
        </button>
        
        {testResults && (
          <div className="mt-4 p-4 bg-gray-50 rounded-lg">
            <h3 className="font-semibold mb-2">ผลการทดสอบ:</h3>
            <div className="space-y-2">
              <div className="flex items-center">
                <span className="mr-2">CORS:</span>
                <span className={`px-2 py-1 rounded text-sm ${
                  testResults.cors ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'
                }`}>
                  {testResults.cors ? '✅ สำเร็จ' : '❌ ล้มเหลว'}
                </span>
              </div>
              
              <div className="flex items-center">
                <span className="mr-2">การเชื่อมต่อ:</span>
                <span className={`px-2 py-1 rounded text-sm ${
                  testResults.connection ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'
                }`}>
                  {testResults.connection ? '✅ สำเร็จ' : '❌ ล้มเหลว'}
                </span>
              </div>
              
              <div className="flex items-center">
                <span className="mr-2">การอัพโหลด:</span>
                <span className={`px-2 py-1 rounded text-sm ${
                  testResults.upload ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'
                }`}>
                  {testResults.upload ? '✅ สำเร็จ' : '❌ ล้มเหลว'}
                </span>
              </div>
              
              {testResults.errors.length > 0 && (
                <div className="mt-2">
                  <span className="font-medium text-red-600">ข้อผิดพลาด:</span>
                  <ul className="list-disc list-inside text-sm text-red-600">
                    {testResults.errors.map((error, index) => (
                      <li key={index}>{error}</li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          </div>
        )}
        
        <div className="mt-4 p-4 bg-blue-50 rounded-lg">
          <h4 className="font-semibold text-blue-800 mb-2">💡 คำแนะนำ:</h4>
          <ul className="text-sm text-blue-700 space-y-1">
            <li>• เปิด Developer Console (F12) เพื่อดู log รายละเอียด</li>
            <li>• ถ้าทดสอบสำเร็จ ระบบอัพโหลดรูปภาพควรทำงานได้</li>
            <li>• ถ้าทดสอบล้มเหลว ให้ตรวจสอบ Firebase Storage Rules</li>
            <li>• ตรวจสอบว่า user ล็อกอินแล้วหรือไม่</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default StorageTest;
